export default "__VITE_ASSET__BCnp0qT6__"